<script>
  import { layoutMethods, rouletteMethods, rouletteComputed, erpUserRolesMethods} from "@/state/helpers";
  import { required } from "vuelidate/lib/validators";
  import ImageUploader from "@/components/ImageUploader";
  import Multiselect from "vue-multiselect";
  import InputColorPicker from 'vue-native-color-picker';
  import Swal from "sweetalert2";
  import { getModuleAccess } from '@/router/helper.js'

  export default {
    page: {
      title: "Roulette Main"
    },
    data() {
      return {
        title: "Roulette Item",
        itemId: 0,
        iconLogo: {
          filename: null,
          type: null,
          base64: null,
        },
        pagination: {
            "page": 1,
            "rows" : 1,
            "search": "",
            "search_field": "",
            "filter": "",
            "filter_by": ""
        },
        folder: 'roleta-images',
        isEditModal: false,
        hideAmount: true,
        hideStock: true,
        logoPreview: "",
        form: {
          itemId                : "",
          itemKey               : "",
          itemName              : "",
          itemBackgroundColor   : "#ee92f4",
          itemType              : "",
          itemChancePercentage  : 0.0,
          itemChance            : 0,
          itemOriginalChance    : 0,
          itemOriginalRouletteId: 0,
          itemOriginalItemStock: 0,
          itemOriginalItemType: "",
          itemRewin             : 0,
          itemStock             : "",
          itemAmount            : "",
          itemIsEload           : 0,
          rouletteId            : 0,
          itemStatus            : 1,
          itemStatusDefault     : 0,
          itemRandomizer            :{
                                    random  : 0,
                                    min     : 0,
                                    max     : 0,
                                },
          itemIconLink          : ""
        },
        temp: {},
        backupdata : {},
        editItemLoaded: false,
        totalItemChancesLoaded: false,
        submitted: false,
        totalItemChances: 0,
        typeOptions:[
          {
            text: "Coins", 
            value: "coins"
          },
          {
            text: "Physical Prize", 
            value: "logistics"
          },
          {
            text: "Ticket", 
            value: "ticket"
          },
          {
            text: "None", 
            value: "none"
          },
        ],
        rouletteOptions2:[
          {
            text: "Daily Roleta", 
            value: "1"
          },
          {
            text: "Grand Weekly Roleta", 
            value: "2"
          },
          {
            text: "Roleta Promo", 
            value: "3"
          },
        ],
        rouletteOptions: [],
        colour: '#000000',
        rouletteItemModule: {
          access: {
            udpate: true
          }
        }
      };
    },
    validations: {
      form: {
            itemKey                : {required},
            itemName               : {required},
            itemStock              : {required},
            itemAmount             : {required},
            itemChance             : {required}
          },
     },
    components: {
      ImageUploader,
      Multiselect,
      "v-input-colorpicker": InputColorPicker

    },
    
    
    methods: {
      ...layoutMethods,
      ...rouletteMethods,
      // ...rouletteComputed,
      ...erpUserRolesMethods,
      async fetchRouletteMainDropdown() {
        await this.listRouletteMainDropdown()
          .then((res) => {
            console.log("Roulete main dropdown response: ", res);

            this.rouletteMainDropdown.forEach(element => {
              this.rouletteOptions.push({
                text: element.title,
                value: element.id
              });
            });
          })
          .catch((error) => {
            console.log("Error in fetching Main Roulette: ", error);
          });
      },
      updateItem() {
        var itemObj = { ...this.form };
        itemObj.itemIconLink = itemObj.itemIconKey;
        if (this.iconLogo.base64) {
          var iconLogo = { ...this.iconLogo };
          iconLogo.folder = this.folder;
          this.uploadLogo(iconLogo)
            .then((imageKey) => {
              itemObj = {
                ...itemObj,
                itemIconLink: imageKey,
              };
              this.update(itemObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!", `${err}`, "error");
            });
        } else {
          this.update(itemObj);
        }
      },
      createItem(){
        var itemObj = { ...this.form };
        if(this.iconLogo.base64){
          var iconLogo = { ...this.iconLogo };
          iconLogo.folder = this.folder;
          this.uploadLogo(iconLogo)
            .then((imageKey) => {
              itemObj = { 
                ...itemObj,
                itemIconLink: imageKey
              }
              this.create(itemObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        } else {
          this.create(itemObj);
        }
      },
      checkForm() {
        this.submitted = true
        this.$v.$touch();
        if (!this.$v.form.$invalid){
          this.itemId=this.$route.params.id;
          if (this.itemId) {
            this.updateItem();
          } else {
            this.createItem();
          }
        }
        
      },
      clearLogo() {
        this.iconLogo = {
          filename: null,
          type: null,
          base64: null,
        };
      },
      create(itemObj){
        this.createRouletteItem(itemObj)
          .then((data) => {
            this.createModal = false;
            if(data.status == "err"){
              Swal.fire("", data.message ,"error");
            }
            else if(data.status == "warning"){
              Swal.fire("", data.message ,"warning");
            } else {
                Swal.fire("Create Successful!", `${itemObj.itemName} prize has been created.`, "success");
                this.clearLogo();
                this.$router.push(
                this.$route.query.redirectFrom || {
                    name: "Roulette Item",
                  }
                );
            }
          })
          .catch((e) => {
            this.createModal = false;
            Swal.fire("Create Failed!",`${itemObj.itemName} prize was not created. Reason: ${e}`, "danger");
          });
      },
      retrieveData(id){
        this.logoPreview = null;
        this.getRouletteItem(id).then((item) => {
          this.backupRecord(item);
          this.temp = {...item, itemOriginalChance: item.itemChance, itemStatusDefault: item.itemStatus, itemOriginalRouletteId: item.rouletteId, itemOriginalItemStock: item.itemStock, itemOriginalItemType: item.itemType};
          this.form  = {...item, itemOriginalChance: item.itemChance, itemStatusDefault: item.itemStatus, itemOriginalRouletteId: item.rouletteId, itemOriginalItemStock: item.itemStock, itemOriginalItemType: item.itemType};
          this.editItemLoaded = true;
          this.getRouletteItemPercentages(this.form.rouletteId).then(chances => {
            this.totalItemChancesLoaded = true;
            this.totalItemChances = chances;
          })
          .catch(err => {
              console.log(err);
          });
          this.hideFields(item.itemType);
        })
        .catch(e => {
            console.log("error", e);
        });    
      },
      backupRecord(data){
        var record = JSON.stringify(data);
        localStorage.setItem('roletaItem', record);
        
      },
      onIsEloadUpdate()
      {
          this.form.itemType = this.form.itemType != 'coins' ? 'coins' : 'none'
      },
      update(itemObj){
        console.log(this.temp,itemObj);
        if(this.temp == itemObj){
            Swal.fire("",  "No change has been made!." ,"warning");
            return;
        }
        this.updateRouletteItem(itemObj)
          .then((data) => {
            console.log(data);
            this.createModal = false;
            this.listRouletteItem();
            this.clearLogo();
            if(data.status == "err"){
              Swal.fire("", data.message ,"error");
            }
            else if(data.status == "warning")
            {
              Swal.fire("", data.message , data.status);
            } else {
              Swal.fire("Update Successful!", `Item ${itemObj.itemName} Prize has been updated.`,"success");
              if((this.form.itemStatusDefault != this.form.itemStatus))
              {
                this.retrieveData(this.itemId);
                return;
              }

              // Send the user to the dashboard
              this.$router.push(
                this.$route.query.redirectFrom || {
                  name: "Roulette Item",
                }
              );
              
              
            }
            
          })
          .catch((e) => {
            this.createModal = false;
            this.clearLogo();
            Swal.fire("Update Failed!", `Item ${itemObj.itemName} Prize was not updated. Reason: ${e}`,"danger");
          });
      },
      hideFields(params){
        var roletaItem = JSON.parse(localStorage.getItem('roletaItem'));
        if(params == 'logistics'){
          this.form.itemStock   = roletaItem != null ? roletaItem.itemStock : this.form.itemStock;
          this.form.itemAmount  = 0;
          this.hideAmount       = false;
          this.hideStock        = true;
        } else if(params == 'coins'){
          this.form.itemAmount   = roletaItem != null ? roletaItem.itemAmount : this.form.itemAmount;
          this.form.itemStock  = 0;
          this.hideAmount       = true;
          this.hideStock        = false;
        } else if(params == 'ticket'){
          this.form.itemStock   = roletaItem != null ? roletaItem.itemStock : this.form.itemStock;
          this.form.itemAmount  = roletaItem != null ? roletaItem.itemAmount : this.form.itemAmount;
          this.hideAmount       = true;
          this.hideStock        = true;
        } else if(params == 'none'){
          this.form.itemAmount = 0;
          this.form.itemStock = 0;
          this.hideStock = false;
          this.hideAmount = false;
        } else if(this.form.itemIsEload == 1){
          this.hideStock = true;
          this.hideAmount = true;
          this.form.itemStock = roletaItem != null ? roletaItem.itemStock : this.form.itemStock;
          this.form.itemAmount = roletaItem != null ? roletaItem.itemAmount : this.form.itemAmount;
        }
      },
    },
    computed: {
      ...rouletteComputed,
      roulletteItemType: {
        get(){
          var _itemType = null;
          this.typeOptions.forEach(b => {
            if(b.value == this.form.itemType)
              _itemType = b;
           });
          return _itemType;
        },
        set(_itemType)
        {
          if(_itemType){
            this.form.itemType = _itemType.value;
          } else {
            this.form.itemType = "none";
          }
          this.hideFields(this.form.itemType);
        }
      },
      rouletteWheelType: {
        get(){
          var _rouletteType = null;
          this.rouletteOptions.forEach(b => {
            if(b.value == this.form.rouletteId)
              _rouletteType = b;
           });
          
          return _rouletteType;
        },
        set(_rouletteType)
        {
          if(_rouletteType){
            this.form.rouletteId = _rouletteType.value;
          } else {
            this.form.rouletteId = null;
          }
        }
      },
    },
    watch: {
      'form.rouletteId': function(newVal) {
        
        this.getRouletteItemPercentages(newVal).then(chances => {
            this.totalItemChancesLoaded = true;
            this.totalItemChances = chances;
          })
          .catch(err => {
              console.log(err);
          });
      },
      'form.itemRewin': function (newVal) {
          this.form.itemRewin = newVal | 0;
      },
      'form.itemIsEload': function (newVal) {
          this.form.itemIsEload = newVal | 0;
          if(!(newVal | 0)) 
          {
            this.form.itemType = 'none';
            this.hideFields('none');
          }
          else this.hideFields();
      },
      'form.itemRandomizer.random': function (newVal) {
          if(this.form.itemRandomizer.random == true) this.form.itemRandomizer.random = newVal | 0;
      },
      'form.itemStatus': function (newVal) {
          this.form.itemStatus = newVal | 0;
          
      },
      'form.itemAmount': function (newVal){
          if(Object.prototype.hasOwnProperty.call(newVal, 'length'))
          {
            var temp = parseInt(newVal)
            var amount = isNaN(temp) || newVal.length == null ? 0 : parseInt(newVal.toString().replace(/[^\d]+/g,''));
            this.form.itemAmount = amount;
          }
          
      },
      'form.itemRandomizer.min': function (newVal){
          if(Object.prototype.hasOwnProperty.call(newVal, 'length'))
          {
            var temp = parseInt(newVal)
            var amount = isNaN(temp) || newVal.length == null ? 0 : parseInt(newVal.toString().replace(/[^\d]+/g,''));
            this.form.itemRandomizer.min = amount;
          }
      },
      'form.itemRandomizer.max': function (newVal){
          if(Object.prototype.hasOwnProperty.call(newVal, 'length'))
          {
            var temp = parseInt(newVal)
            var amount = isNaN(temp) || newVal.length == null ? 0 : parseInt(newVal.toString().replace(/[^\d]+/g,''));
            this.form.itemRandomizer.max = amount;
          }
      },
      'form.itemChance': function (newVal){
        if(Object.prototype.hasOwnProperty.call(newVal, 'length'))
        {
            var temp = parseInt(newVal)
            var amount = isNaN(temp) || newVal.length == null ? 0 : parseInt(newVal.toString().replace(/[^\d]+/g,''));
            this.form.itemChance = amount;
        }
      },
      'form.itemStock': function (newVal){
        if(Object.prototype.hasOwnProperty.call(newVal, 'length'))
        {
          var temp = parseInt(newVal)
          var amount = isNaN(temp) || newVal.length == null ? 0 : parseInt(newVal.toString().replace(/[^\d]+/g,''));
          this.form.itemStock = amount;
        }
      },
    },
    async mounted(){
      this.changeTitle({title: 'Roulette Main'});
      this.itemId = this.$route.params.id;
      if (this.itemId > 0) {
        this.editItemLoaded = false;
        localStorage.removeItem('roletaItem')
        this.retrieveData(this.itemId);

      }
      else {
        this.form.itemAmount = 0;
          this.form.itemStock = 0;
          this.hideStock = false;
          this.hideAmount = false;
      }
      this.changeTitle({
        title: (this.itemId > 0 ? "Update" : "Add") + " Roulette Item Prize",
      });
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Roulette Item', to: { name: 'Roulette Item'} },
          { text: 'Roleta Prize', to: { name: 'Roulette Item'} },
        ]
      });
      this.fetchRouletteMainDropdown();

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Roulette', 'Roulette Item')
        .then((access) => this.rouletteItemModule.access = access);

    }
  }
    
</script>
<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <!-- modal -->
        <div v-if="false">
          <div class="card">
            <div class="card-body" v-if="!isEditModal">
              <div v-if="false">
                This is Add Roulette Prizes New Page {{ itemId }}
              </div>
            </div>
            <div class="card-body" v-if="isEditModal">
              <image-upload
                v-model="iconLogo"
                :imageSrc="form.itemIconLink"
                label="Roulette Item Logo"
                :isRequired="false"
              />
            </div>

            <div class="card-footer card-footer-pink">
              <a>
                <i class="fas fa-image"></i>
                Upload Image
              </a>
            </div>
          </div>
          <!-- end of card-->
        </div>
        <!-- end modal -->

        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              class="me-4"
              v-model="iconLogo"
              :isRequired="true"
              :imageSrc="form.itemIconLink"
            />
          </div>
          <!-- end of img upload-->

          
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="max-width: 620px">
                <div class="row">
                  <label v-if="itemId > 0 && !rouletteItemModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a Roulette Item.</label>
                    <div class="col-md-12 mb-3">
                      <label class="form-label"
                        >Item Prize Name<span style="color: red">*</span></label
                      >
                      <!-- <input
                        type="text"
                        class="form-control"
                        id="addcontact-name-input"
                        v-model="form.itemName"
                        placeholder="Enter Prize Name"
                        :class="{
                              'is-invalid': $v.form.itemName.$error,
                          }"
                      /> -->
                      <validation-provider
                        name="prizename"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                      <b-form-textarea
                          id="textarea"
                          v-model="form.itemName"
                          name="prizename"
                          placeholder="Enter Prize Name"
                          rows="3"
                          max-rows="6"
                          :class="{
                            'is-invalid': errors[0],
                        }"
                        ></b-form-textarea>
                        
             
                      <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                   </div>
                   <div class="col-md-12 mb-3">
                    <label class="form-label"
                      >Item Prize Key<span style="color: red">*</span></label
                    >
                    <validation-provider
                        name="itemkey"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                    <input
                      type="text"
                      class="form-control"
                      name="itemkey"
                      id="addcontact-name-input"
                      v-model="form.itemKey"
                      placeholder="Enter Prize Key"
                      :class="{
                            'is-invalid': errors[0],
                        }"
                    />
                    <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <div class="col-md-6 mb-3" v-if="hideStock">
                    <label class="form-label"
                      >Stock<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="addcontact-name-input"
                      v-model="form.itemStock"
                      placeholder="Enter Stock"
        
                    />
                    <label v-if="form.itemStock < 1 && form.itemType != ''" class="form-label item-percentage">This {{form.itemType == 'logistics' && form.itemIsEload == 0 ? 'logistic' : 'eload' }} item prize is <b :style="[{color: 'red'}]">Out of Stock!</b> for <b>{{ rouletteWheelType != null ? rouletteWheelType.text : ""}}</b>.</label> 
                  </div>
                  <div class="col-md-6 mb-3" v-if="hideAmount">
                    <label class="form-label"
                      >Amount<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="addcontact-name-input"
                      v-model="form.itemAmount"
                      placeholder="Enter Amount"
            
                    />
                  </div>

                  

                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold"
                      >Roulette<span style="color: red">*</span></label
                    >
                    <validation-provider
                      name="rouletteType"
                      rules="required"
                      v-slot="{ errors, ariaMsg }"
                    >
                      <multiselect
                        v-model="rouletteWheelType"
                        :options="rouletteOptions"
                        track-by="value"
                        label="text"
                        name="rouletteType"
                        select-label="Click to select"
                        deselect-label="Click to remove"
                        placeholder="Select Roulette"
                        :allow-empty="false"
                        :preselect-first="false"
                        :class="{
                          invalid: errors[0]
                        }"
                      ></multiselect>
                      <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  
                  
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        v-model="form.itemIsEload"
                        type="checkbox"
                        id="iseload"
                        @input="onIsEloadUpdate()"
                      />
                      <label
                        class="form-check-label"
                        for="iseload"
                        >Is E-Load Prize</label
                      >
                    </div>
                  </div>
                  <div class="col-md-6 mb-3" v-if="form.itemIsEload == 0">
                       <label class="form-label"
                      >Type<span style="color: red">*</span></label
                    >
                    <validation-provider
                      name="itemType"
                      rules="required"
                      v-slot="{ errors, ariaMsg }"
                    >
                      <multiselect
                        v-model="roulletteItemType"
                        :options="typeOptions"
                        track-by="value"
                        label="text"
                        name="itemType"
                        select-label="Click to select"
                        deselect-label="Click to remove"
                        placeholder="Select Item Type"
                        :allow-empty="false"
                        :class="{
                          invalid: errors[0],
                        }"
                      ></multiselect>
                      <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <div class="col-md-6 mb-3" v-if="form.itemStatus == 1">
                    <label class="form-label"
                      >Chance</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="addcontact-name-input"
                      v-model="form.itemChance"
                      placeholder="Enter Chance"
                
                    />
                    <div v-if="form.itemType == 'coins' || form.itemType == 'none'">
                      <div v-if="form.itemStatus == 1 && !(form.itemStatusDefault == 0 && form.itemStatusDefault != form.itemStatus && form.itemStatus == 1)">
                        
                        <div v-if="itemId > 0"> 
                          <div v-if="form.rouletteId == form.itemOriginalRouletteId"> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (form.itemChance > form.itemOriginalChance ? totalItemChances + (form.itemChance - form.itemOriginalChance) : totalItemChances - (form.itemOriginalChance - form.itemChance)) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                          <div v-else> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                        </div>
                        <div v-else> 
                          <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                        </div>
                        
                      </div>
                      <div v-else>
                        <div v-if="(form.itemStatusDefault == 0 && form.itemStatusDefault != form.itemStatus && form.itemStatus == 1)">
                          <div v-if="itemId > 0"> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                          
                          <div v-else> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                        </div>
                      </div> 
                    </div>
                    <div v-else>
                      <div v-if="(form.itemType == 'logistics' || form.itemType == 'ticket' || form.itemIsEload == 1 && form.itemType == 'coins') && form.itemOriginalItemStock == 0 && form.itemStock > 0 || (form.itemOriginalItemType == 'coins' || form.itemOriginalItemType == 'none') && (form.itemType == 'logistics' || form.itemIsEload == 1 && form.itemType == 'coins') && form.itemOriginalItemStock == 0 && form.itemStock > 0">
                        <div v-if="(form.itemOriginalItemType == 'coins' || form.itemOriginalItemType == 'none') && (form.itemType == 'logistics' || form.itemIsEload == 1 && form.itemType == 'coins') && form.itemOriginalItemStock == 0 && form.itemStock > 0">
                            <div v-if="form.rouletteId == form.itemOriginalRouletteId"> 
                              <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (form.itemChance > form.itemOriginalChance ? totalItemChances + (form.itemChance - form.itemOriginalChance) : totalItemChances - (form.itemOriginalChance - form.itemChance)) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                            </div>
                            <div v-else> 
                              <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                            </div>
                        </div>
                        <div v-else>
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                        </div>
                        
                      </div>
                      
                      <div v-else-if="(form.itemStatus == 1 && ((form.itemType == 'logistics' || form.itemType == 'ticket' || form.itemIsEload == 1 && form.itemType == 'coins') && form.itemStock > 0)) && !(form.itemStatusDefault == 0 && form.itemStatusDefault != form.itemStatus && form.itemStatus == 1)">
                        
                        <div v-if="itemId > 0"> 
                          <div v-if="form.rouletteId == form.itemOriginalRouletteId"> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (form.itemChance > form.itemOriginalChance ? totalItemChances + (form.itemChance - form.itemOriginalChance) : totalItemChances - (form.itemOriginalChance - form.itemChance)) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                          <div v-else> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                        </div>
                        <div v-else> 
                          <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                        </div>
                        
                      </div>
                      <div v-else-if="(form.itemType == 'logistics' || form.itemType == 'ticket' || form.itemIsEload == 1 && form.itemType == 'coins') && form.itemStock < 1">  
                          <label v-if="form.itemChance > 0" class="form-label item-percentage">This item prize is currently <b :style="[{color: 'red'}]">Out of Stock</b> for <b>{{rouletteWheelType.text}}</b>. <b :style="[{color: 'green'}]">Add Stock</b> first before changing the chances.</label>
                      </div>
                      <div v-else>
                        <div v-if="(form.itemStatusDefault == 0 && form.itemStatusDefault != form.itemStatus && form.itemStatus == 1)">
                          <div v-if="itemId > 0"> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                          
                          <div v-else> 
                            <label v-if="form.itemChance > 0" class="form-label item-percentage">Winning chance percentage: <b v-if="totalItemChances > 0">{{(form.itemChance / (totalItemChances + form.itemChance) * 100).toFixed(2)}}%</b> <b v-else>calculating</b> for {{rouletteWheelType.text}}.</label>
                          </div>
                        </div>
                      
                      </div> 
                    </div>
                  </div> 
                  <div class="col-md-6 mb-3">
                    <label class="form-label"
                      >Background Color<span style="color: red">*</span></label
                    >
                    <br/>
                    <v-input-colorpicker  
                      v-model="form.itemBackgroundColor" 
                    />
                  </div>
                
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        v-model="form.itemRewin"
                        type="checkbox"
                        id="rewin"
                      />
                      <label
                        class="form-check-label"
                        for="rewin"
                        >Re-Win</label
                      >
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        v-model="form.itemRandomizer.random"
                        type="checkbox"
                        id="ramdomizer"
                      />
                      <label
                        class="form-check-label"
                        for="ramdomizer"
                        >Randomizer</label
                      >
                    </div>
                  </div>
                  <div v-if="form.itemRandomizer.random == 1">
                    <div class="col-md-6 mb-3">
                      <label class="form-label"
                        >MIN<span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="addcontact-name-input"
                        v-model="form.itemRandomizer.min"
                        placeholder="Enter Amount"
          
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label"
                        >MAX<span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="addcontact-name-input"
                        v-model="form.itemRandomizer.max"
                        placeholder="Enter Amount"
                      
                      />
                    </div>
                  </div>  
                    <div class="col-md-12  mb-3">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          v-model="form.itemStatus"
                          type="checkbox"
                          id="itemStatus"
                        />
                        <label
                          class="form-check-label"
                          for="itemStatus"
                          >Status : <span :style="[ form.itemStatus == 0 ? {color: 'red'} : {color: 'green'} ]">{{ form.itemStatus == 0 ? 'Deactivated' : 'Activated'}}</span></label
                        >
                      </div>
                    </div>
                    <b-row class="mb-3">
                      <b-col
                        ><b-btn :disabled="!rouletteItemModule.access.update" class="w-100" type="submit" variant="primary"
                          >Save</b-btn
                        ></b-col
                      >
                      <b-col>
                        <router-link :to="{ name: 'Roulette Item', params: {} }" class="tc-white">
                            <b-button
                              variant="light"
                              class="w-sm w-100p"
                              type="button"
                              >Cancel</b-button
                            >
                        </router-link>
                        <!-- <b-btn class="w-100 btn btn-light" >
                          
                        </b-btn> -->
                      </b-col>
                    </b-row>      
                </div>
             </div>
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> 
    </ValidationObserver
    ><!-- end of validation observer-->
  </div>
  <!-- end of row-->
</template>
<!-- <template>
  <div>
      This is Roulette Main New Page
  </div>
</template> -->

<style>
  .form-label.item-percentage {
      color: #aaaaaa;
      font-size: 11px !important;
  }
  .multiselect.invalid .multiselect__tags {
  border-color: #f34e4e !important;
  padding-right: calc(1.5em + 0.94123rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.235rem) center !important;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem) !important;
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}
</style>